var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card",class:['card-' + _vm.cardIndex],style:(_vm.cardBackground),attrs:{"id":'item-' + _vm.cardIndex}},[_c('div',{staticClass:"mem-font--obstacle-card__title card-title"},[_vm._v(_vm._s(_vm.$t(_vm.obstacle.name_i18n_key)))]),_c('div',{staticClass:"card-subline"},[_vm._v(_vm._s(_vm.$t(_vm.obstacle.subline_i18n_key)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }